export default {
  SET_TABS: 'setTabs',
  HANDLE_GET_ACCOUNT_MANAGER_INFO: 'handleGetAccountManagerInfo',
  HANDLE_GET_NEWS: 'handleGetNews',
  TOGGLE_MENU: 'toggleMenu',
  HANDLE_BLOCK_UNBLOCK_UI: 'handleBlockUnblockUi',
};



// WEBPACK FOOTER //
// ./src/app/main/layout/constants/action-types.js